const Label = ({ label, disabled, required, htmlFor }) => {
  return (
    <div
      htmlFor={htmlFor}
      className={`edexlms-field-label ${(required && "required") || ""} ${
        disabled ? "disabled" : ""
      }`}
    >
      {label}
    </div>
  );
};

export default Label;
